
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { createArrayCopyAndSort } from './editActions/ScheduleCalc';
import { addDays } from '@helpers/DateHelper';

interface IHandoverData {
  atSchool:boolean;
  time:number
  location:string|undefined;
}

// returns a list of all changed days
const calculateChangedDays = (baseSchedule:ISchedule, alteredSchedule:ISchedule):IDateRange[] => {

  const baseA = createArrayCopyAndSort(baseSchedule.data.scheduleEntriesParentA);
  const alteredA = createArrayCopyAndSort(alteredSchedule.data.scheduleEntriesParentA);

  let range =  calculateChangedDaysSide(baseA, alteredA);

  if (range.length === 0) {
    const baseB = createArrayCopyAndSort(baseSchedule.data.scheduleEntriesParentB);
    const alteredB = createArrayCopyAndSort(alteredSchedule.data.scheduleEntriesParentB);
  
    range =  calculateChangedDaysSide(baseB, alteredB);
  }

  return range;
}

// returns a list of all changed days
const calculateChangedDaysSide = (baseSchedule:IScheduleEntry[], altSchedule:IScheduleEntry[]):IDateRange[] => {

  if (baseSchedule.length > 0 && altSchedule.length > 0) {

    const changedDays:IDateRange[] = [];

    const scheduleStartTime = Math.min(baseSchedule[0].startTime, altSchedule[0].startTime);
    const scheduleEndTime = Math.max(baseSchedule[baseSchedule.length-1].endTime, altSchedule[altSchedule.length-1].endTime);

    let spinStartOfDay = new Date(scheduleStartTime);
    spinStartOfDay.setMilliseconds(1);
    spinStartOfDay.setHours(0);
    spinStartOfDay.setMinutes(0);
    spinStartOfDay.setSeconds(0);

    let baseIndex = 0;
    let alteredIndex = 0;

    while (spinStartOfDay.getTime() < scheduleEndTime) {
      const startOfDay = (spinStartOfDay.getTime());
      const endOfDay = (startOfDay + (1000*60*60*24));
      const baseStartEvents:IHandoverData[] = [];
      const baseEndEvents:IHandoverData[] = [];
      let baseHasChildWholeDay:boolean = false;
      let bi = baseIndex;
      while (bi < baseSchedule.length  && baseSchedule[bi].startTime < endOfDay) {
        if (baseSchedule[bi].endTime < startOfDay) { // this event no longer is interesting and we can skip it
          baseIndex++;
        } else {
          if (baseSchedule[bi].startTime > startOfDay && baseSchedule[bi].startTime < endOfDay) { // the event starts today
            baseStartEvents.push({atSchool:baseSchedule[bi].startAtSchool, location: baseSchedule[bi].startLoc, time: baseSchedule[bi].startTime});
          }
          if (baseSchedule[bi].endTime > startOfDay && baseSchedule[bi].endTime < endOfDay) { // the event ends today
            baseEndEvents.push({atSchool:baseSchedule[bi].endAtSchool, location: baseSchedule[bi].endLoc, time: baseSchedule[bi].endTime});
          }
          if (baseSchedule[bi].startTime < startOfDay && baseSchedule[bi].endTime > endOfDay) { // the event spans today
            baseHasChildWholeDay = true;
          }
        }
        bi++;
      }

      const altStartEvents:IHandoverData[] = [];
      const altEndEvents:IHandoverData[] = [];
      let altHasChildWholeDay:boolean = false;
      let ai = alteredIndex;
      while (ai < altSchedule.length  && altSchedule[ai].startTime < endOfDay) {
        if (altSchedule[ai].endTime < startOfDay) { // this event no longer is interesting and we can skip it
          alteredIndex++;
        } else {
          if (altSchedule[ai].startTime > startOfDay && altSchedule[ai].startTime < endOfDay) { // the event starts today
            altStartEvents.push({atSchool:altSchedule[ai].startAtSchool, location: altSchedule[ai].startLoc, time: altSchedule[ai].startTime});
          }
          if (altSchedule[ai].endTime > startOfDay && altSchedule[ai].endTime < endOfDay) { // the event ends today
            altEndEvents.push({atSchool:altSchedule[ai].endAtSchool, location: altSchedule[ai].endLoc, time: altSchedule[ai].endTime});
          }
          if (altSchedule[ai].startTime < startOfDay && altSchedule[ai].endTime > endOfDay) { // the event spans today
            altHasChildWholeDay = true;
          }
        }
        ai++;
      }

      if (altHasChildWholeDay !== baseHasChildWholeDay || altStartEvents.length !== baseStartEvents.length 
        || altEndEvents.length !== baseEndEvents.length) {
        addRange(changedDays, startOfDay, endOfDay);
      } else {
        let hasAdded = false;
        for (let index = 0; index < baseStartEvents.length; index++) {
          const base = baseStartEvents[index];
          const alt = altStartEvents[index];
          
          if (base.atSchool !== alt.atSchool || (!base.atSchool  && (base.time !== alt.time || base.location !== alt.location))) {
            addRange(changedDays, startOfDay, endOfDay);
            hasAdded = true;
            break;
          }
        }
        if (!hasAdded) {
          for (let index = 0; index < baseEndEvents.length; index++) {
            const base = baseEndEvents[index];
            const alt = altEndEvents[index];
            
            if (base.atSchool !== alt.atSchool || (!base.atSchool  && (base.time !== alt.time || base.location !== alt.location))) {
              addRange(changedDays, startOfDay, endOfDay);
              break;
            }
          }
        }
      }

      spinStartOfDay = addDays(spinStartOfDay,1);
    }

    return changedDays;
  }

  return [];
}


const addRange = (dates:IDateRange[], start:number, end:number) => {
  if (dates.length === 0 || ((dates[dates.length -1].end+(1000*60*60*2)) < start)) {
    dates.push({start, end});
  } else {
    dates[dates.length - 1].end = end;
  }
}


export { calculateChangedDays };


// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/ChangeTimePlaceCalc.ts